import type { CartItem } from 'src/graphql/generated';

export const getJobIdFromCart = (cartItems?: CartItem[]) => {
  const cartItemWithJobId = cartItems?.find((cartItem) =>
    // @ts-ignore
    Boolean(cartItem.product?.job?.id),
  );
  // @ts-ignore
  return cartItemWithJobId?.product?.job?.id;
};
